import React, { useEffect, useState } from 'react';
import { API_URL } from '../../config';
import { authFetch } from '../../utils';
import telegramLogo from '../../assets/telegram-logo.png';
import SmokeDetectorForm from './SmokeDetectorForm';

function getVocSensor(firmwareVersion) {
  const version = parseInt(firmwareVersion, 10);
  return version >= 3 && version <= 10 ? 'SGP40' : 'SGPC30';
}

export default function SmokeDetectorList({ onSaved }) {
  const [detectors, setDetectors] = useState([]);
  const [searchId, setSearchId] = useState('');
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [editingDetectorId, setEditingDetectorId] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);

  useEffect(() => {
    authFetch(`${API_URL}smoke-detectors/`)
      .then(res => res.json())
      .then(setDetectors);
  }, []);

  const handleDelete = async (detectorId) => {
    const confirmDelete = window.confirm('¿Estás seguro de que deseas eliminar este detector?');
    if (!confirmDelete) return;

    const res = await authFetch(`${API_URL}smoke-detectors/${detectorId}`, { method: 'DELETE' });
    if (res.status === 200) {
      setDetectors(detectors.filter(d => d.detectorId !== detectorId));
      setDeleteSuccess(true);
      setTimeout(() => setDeleteSuccess(false), 3000);
    } else {
      alert(`Error al eliminar el detector. Código: ${res.status}`);
    }
  };

  const filteredDetectors = detectors.filter(d =>
    d.detectorId?.toLowerCase().includes(searchId.toLowerCase()) ||
    d.name?.toLowerCase().includes(searchId.toLowerCase()) ||
    d.location?.name?.toLowerCase().includes(searchId.toLowerCase()) ||
    d.facility?.name?.toLowerCase().includes(searchId.toLowerCase()) ||
    getVocSensor(d.firmware_version).toLowerCase().includes(searchId.toLowerCase())
  );

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '1rem' }}>
      <h2 style={{ fontSize: '1.8rem', marginBottom: '1rem', textAlign: 'center' }}>
        🔥 Detectores de Humo
      </h2>

      <button
        onClick={() => setShowCreateForm(true)}
        style={{ backgroundColor: '#28a745', color: '#fff', border: 'none', padding: '0.5rem 1rem', borderRadius: '4px', cursor: 'pointer', marginBottom: '1rem' }}
      >
        ➕ Nuevo detector
      </button>

      {showCreateForm && (
        <SmokeDetectorForm
          detector={null}
          onSave={(newDetector) => {
            setDetectors(prev => [...prev, newDetector]);
            setShowCreateForm(false);
          }}
          onCancel={() => setShowCreateForm(false)}
        />
      )}

      <input
        type="text"
        value={searchId}
        onChange={e => setSearchId(e.target.value)}
        placeholder="Buscar por ID, nombre o ubicación..."
        style={{
          width: '100%',
          padding: '0.75rem',
          fontSize: '1rem',
          marginBottom: '1.5rem',
          borderRadius: '6px',
          border: '1px solid #ccc'
        }}
      />

      {deleteSuccess && (
        <div style={{
          backgroundColor: '#d4edda',
          color: '#155724',
          padding: '0.75rem',
          borderRadius: '6px',
          border: '1px solid #c3e6cb',
          marginBottom: '1rem',
          textAlign: 'center'
        }}>
          ✅ Detector eliminado correctamente
        </div>
      )}

      <ul style={{ listStyle: 'none', padding: 0 }}>
        {filteredDetectors.map(detector => (
          <li
            key={detector._id}
            style={{
              backgroundColor: '#f9f9f9',
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '1rem',
              marginBottom: '1rem',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}
          >
            {editingDetectorId === detector.detectorId ? (
              <SmokeDetectorForm
                detector={{
                  ...detector,
                  location: typeof detector.location === "string"
                    ? { _id: detector.location }
                    : detector.location,
                  facility: typeof detector.facility === "string"
                    ? { _id: detector.facility }
                    : detector.facility
                }}
                onSave={(updatedDetector) => {
                  setDetectors(prev =>
                    prev.map(d => d.detectorId === updatedDetector.detectorId ? updatedDetector : d)
                  );
                  setEditingDetectorId(null);
                }}

                onCancel={() => setEditingDetectorId(null)}
              />
            ) : (
              <>
                <div style={{ marginBottom: '0.5rem' }}>
                  <strong>ID:</strong> {detector.detectorId}
                </div>
                <div><strong>Nombre:</strong> {detector.name}</div>
                <div><strong>Ubicación:</strong> {detector.location?.name || 'Sin asignar'}</div>
                <div><strong>Instalación:</strong> {detector.facility?.name || 'Sin asignar'}</div>
                <div><strong>Descripción:</strong> {detector.description || '—'}</div>
                <div><strong>Sensor VOC:</strong> {getVocSensor(detector.firmware_version)}</div>

                <div style={{ marginTop: '0.5rem' }}>
                  <strong>Alarmas:</strong>
                  <ul style={{ paddingLeft: '1rem', marginTop: '0.25rem' }}>
                    <li>🔔 Activada: {detector.alarmEnabled ? 'Sí' : 'No'}</li>
                    <li>📩 SMS: {detector.alarmSMS ? 'Sí' : 'No'}</li>
                    <li>📞 Llamada: {detector.alarmPhoneCall ? 'Sí' : 'No'}</li>
                    <li>
                      <img
                        src={telegramLogo}
                        alt="Telegram"
                        height={18}
                        width={18}
                        style={{ verticalAlign: 'middle', marginRight: '0.25rem' }}
                      />
                      Telegram: {detector.alarmTelegram ? 'Sí' : 'No'}
                    </li>
                  </ul>
                </div>

                <div style={{ marginTop: '1rem' }}>
                  <button
                    onClick={() => setEditingDetectorId(detector.detectorId)}
                    style={{
                      marginRight: '0.5rem',
                      padding: '0.5rem 1rem',
                      backgroundColor: '#007bff',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    Editar
                  </button>
                  <button
                    onClick={() => handleDelete(detector.detectorId)}
                    style={{
                      padding: '0.5rem 1rem',
                      backgroundColor: '#dc3545',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    Eliminar
                  </button>
                </div>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
